import axios from 'axios';

const API_URL = 'https://phone360.net/api/';

class CustomerService {
 
        async customerList() {
          const token = localStorage.getItem('user');
          if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
          }
          const response = await axios.get(API_URL + 'customers/');
          return response.data; // Geri dönen veriyi döndür
        
      }

      async deleteCustomer(CustomerId) {
        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }
        const response = await axios.delete(API_URL + 'customers/'+CustomerId);
        return response.data;  
      
    }

      
      async addCustomer(CustomerData) {

        const token = localStorage.getItem('user');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
        }
        const response = await axios.post(API_URL + 'customers',CustomerData);
        return response.data; 
      }
}

export default new CustomerService();